import { render, staticRenderFns } from "./WFunctions.vue?vue&type=template&id=2c5c46bc&"
import script from "./WFunctions.vue?vue&type=script&lang=ts&"
export * from "./WFunctions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports